<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="22.8712" y="31.7744" width="25.6246" height="31.4849" stroke="black" stroke-width="4"/>
<path d="M82.0045 18L48.4954 31.7747V63.2596L82.0045 77.0342V18Z" stroke="black" stroke-width="4"/>
<path d="M22.8701 56.3719C17.9713 56.3719 14 52.4073 14 47.5168C14 42.6262 17.9713 38.6617 22.8701 38.6617" stroke="black" stroke-width="4"/>
<path d="M35.3437 62.4473L42.3652 77.2759C43.4207 79.5051 42.4737 82.1553 40.2444 83.2109V83.2109V83.2109C38.0247 84.2619 35.3604 83.31 34.3094 81.0904L26.004 63.5504" stroke="black" stroke-width="4"/>
</svg>

</template>
